import { compKey } from './key';
export var createTableV2Driver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        columnCount: function () { return base.$$('.head-cell-content').count(); },
        columnTitles: function () { return base.$$('.head-cell-content').text(); },
        columnWidths: function () { return base.$$('.table-head-cell').map(function (el) { return el.attr('data-col-width'); }); },
        rowsCount: function () { return base.$$('.table-row').count(); },
        clickRow: function (idx) { return base.$$('.table-row').get(idx).click(); },
        getRowByIdx: function (idx) { return base.$$('.table-row').get(idx); },
        getCell: function (rowIdx, columnClass) {
            var row = base.$$('.table-row').get(rowIdx);
            return row.$("." + columnClass);
        },
        cellValue: function (rowIdx, columnClass) {
            var row = base.$$('.table-row').get(rowIdx);
            return row.$("." + columnClass).text();
        },
        cellValueByIdx: function (rowIdx, columnIdx) {
            var row = base.$$('.table-row').get(rowIdx);
            var cell = row.$$('.table-cell').get(columnIdx);
            return cell.text();
        },
        sortColumnByIdx: function (idx) { return base.$$('.table-head-cell-content.sortable').get(idx).click(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map